import React from "react";
import SidebarMenu from "react-bootstrap-sidebar-menu";
import { useLocation } from "react-router-dom";
import LdsButton from "../LdsButton";
import LdsIcon from "../LdsIcon";

export const SideBar = ({ menuItems = {}, moduleNumber }) => {
  const location = useLocation();

  const generateSideNav = (menuItems) => {
    return menuItems?.map(({ locked = true, path, title, slides }, index) => {
      if (slides?.length) {
        return (
          <SidebarMenu.Sub key={index}>
            <SidebarMenu.Sub.Toggle className={`${locked ? "disabled" : ""}`}>
              <SidebarMenu.Nav.Title>{title}</SidebarMenu.Nav.Title>
              <SidebarMenu.Nav.Icon />
            </SidebarMenu.Sub.Toggle>

            <SidebarMenu.Sub.Collapse>
              <SidebarMenu.Nav>{generateSideNav(slides)}</SidebarMenu.Nav>
            </SidebarMenu.Sub.Collapse>
          </SidebarMenu.Sub>
        );
      }
      return (
        <SidebarMenu.Nav.Link
          key={path}
          disabled={locked}
          href={path}
          eventKey={path}
        >
          <SidebarMenu.Nav.Title>{title}</SidebarMenu.Nav.Title>
        </SidebarMenu.Nav.Link>
      );
    });
  };

  return (
    <div className="col-sm-3 pb-2 mb-5">
      {moduleNumber === 4 ? (
        <LdsButton
          linkButton
          classes="text-align-left col-sm-12 pt-3 pb-3 blue"
          onClick={function navClick() {
            window.open("/module-4/module-4-1-0", "_self");
          }}
        >
          <LdsIcon name="arrow-left blue" inline className="me-1" />
          Return to Dashboard
        </LdsButton>
      ) : null}

      <SidebarMenu expanded activeKey={location.pathname}>
        <SidebarMenu.Collapse>
          <SidebarMenu.Body>
            <SidebarMenu.Nav>{generateSideNav(menuItems)}</SidebarMenu.Nav>
          </SidebarMenu.Body>
        </SidebarMenu.Collapse>
      </SidebarMenu>
    </div>
  );
};
